/* Source: /app/components/ui/ThemeToggle.cl.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { Sun, Moon } from "lucide-react";
import { cn } from "../../lib/utils.js";
function ThemeToggle(props) {
  let theme = (props.theme || "light");
  let onToggle = props.onToggleTheme;
  let className = (props.className || "");
  let isDark = (theme === "dark");
  return __jacJsx("button", {"onClick": onToggle, "className": cn("p-2 rounded-lg transition-all duration-200", "text-text-secondary hover:text-text-primary hover:bg-surface-hover", className), "aria-label": ((isDark && "Switch to light mode") || "Switch to dark mode"), "title": ((isDark && "Switch to light mode") || "Switch to dark mode")}, [(isDark && __jacJsx(Sun, {"className": "w-5 h-5"}, [])), (!isDark && __jacJsx(Moon, {"className": "w-5 h-5"}, []))]);
}
export {ThemeToggle};